import EliminatoriaCompartida from "./EliminatoriaCompartida";

const Octavos = () => (
  <EliminatoriaCompartida
    fase="octavos"
    titulo="Predicciones Octavos de Final"
    endpoint="/octavos/partidos"
    fechaPrimerPartido="2026-07-08T15:00:00"
  />
);

export default Octavos;
